import { Input } from "antd";
import { useEffect, useState } from "react";

const CustomInput = ({
  label,
  value,
  placeholder,
  onChange,
  required = false,
  requiredMessage = "This field is required",
  validation,
  type = "input",
  onValidationChange = () => {},
  style,
  maxLength,
}) => {
  const [error, setError] = useState("");
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (touched) validate(value);
  }, [value]);

  const validate = (val) => {
    let errorMsg = "";
    if (required && !val?.trim()) {
      errorMsg = requiredMessage;
    } else if (validation?.pattern && !validation.pattern.test(val)) {
      errorMsg = validation.message;
    }
    setError(errorMsg);
    onValidationChange(!errorMsg);
  };

  const handleBlur = () => {
    setTouched(true);
    validate(value);
  };

  return (
    <div style={{ marginBottom: '1rem', marginRight: "1rem", ...style }}>
      {label && (
        <label style={{ fontWeight: 500, display: "block", marginBottom: 4 }}>
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}
      <Input
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        type={type}
        maxLength={maxLength}
        style={{ borderColor: error && touched ? "red" : undefined }}
      />
      {error && touched && <p style={{ color: "red", marginTop: 4 }}>{error}</p>}
    </div>
  );
};

export default CustomInput;
